import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {fuseAnimations} from 'fuseui';
import {FlagsService} from '../utils/flags/flags.service';
import {AuthMyService} from '../auth/auth.service';
import { ActivityLogService } from '../utils/activity-log/activity-log.service';
import { FormsService } from '../forms/forms.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AsyncPipe, I18nPluralPipe } from '@angular/common';
import { MatIconButton } from '@angular/material/button';

@Component({
    selector: 'building-type',
    templateUrl: './building-type.component.html',
    styleUrls: ['./building-type.styles.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    imports: [
    MatIconButton,
    AsyncPipe,
    I18nPluralPipe,
    TranslateModule
],
})
export class BuildingTypeComponent implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    user?: any;
    formsCount: number | undefined = 0;

    constructor(
        private _router: Router,
        public readonly cd: ChangeDetectorRef,
        public translateService: TranslateService,
        public flagService: FlagsService,
        public authService: AuthMyService,
        private _activityLogService: ActivityLogService,
        private _formsService: FormsService,
    ) {

    }

    async ngOnInit(): Promise<void> {
        await this.translateService.get('key').toPromise().then();
        this.cd.detectChanges();
        setTimeout(() => {
            this.cd.detectChanges();
        }, 1000)

        this._activityLogService.logActivity('forms', { screenName: 'Náběrové listy' });

        this.authService.profile().subscribe(user => {
            this.user = user?.user;
            this.cd.detectChanges();

            if (this.user?.id) {
                this._formsService
                    .getUserForms(this.user.id.toString(), true)
                    .pipe(takeUntil(this._unsubscribeAll))
                    .subscribe((response: any) => {
                        this.formsCount = response?.count ?? response?.count ?? -1;
                        this.cd.markForCheck();
                    });
            }
        })

    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    redirectTo(link: string): void {
        sessionStorage.removeItem('formValue');
        this._router.navigate([link]);
    }

}
